"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = exports.APIPath = void 0;
/*
 http.ts
 handles http interactions with the engine's configuration server.
*/
const blackbox_1 = require("../../blackbox");
const axios_1 = __importDefault(require("axios"));
var APIPath;
(function (APIPath) {
    APIPath["StatusItems"] = "/api/status-items";
    APIPath["InfoLogs"] = "/api/info-logs/";
    APIPath["Pallet"] = "/api/pallet/";
    APIPath["Machine"] = "/api/machine/";
    APIPath["CoreAppConfig"] = "/api/app-config";
    APIPath["VRDFConfig"] = "/api/vrdf";
    APIPath["CoreIOConfig"] = "/api/io-config";
    APIPath["GripperConfig"] = "/api/gripper-config";
    APIPath["SKUSpecific"] = "/api/sku-specific";
    APIPath["CoreLogs"] = "/api/core-logs";
    APIPath["SAPIConfig"] = "/api/sapi/config.js/";
    APIPath["Generic"] = "/api/json/";
    APIPath["Pack"] = "/api/pack/";
    APIPath["Queue"] = "/api/queue/";
    APIPath["Command"] = "/api/command/";
    APIPath["Collections"] = "/api/collections/";
    APIPath["FactoryReset"] = "/api/factory-reset";
    APIPath["UploadConfigs"] = "/api/upload-configs";
    APIPath["BaselineConfigs"] = "/api/config-baselines";
    APIPath["Version"] = "/api/version";
})(APIPath = exports.APIPath || (exports.APIPath = {}));
class _Queue {
    constructor(base) {
        this.base = base;
    }
    delete(pID) {
        return axios_1.default.delete(this.base + APIPath.Queue + String(void 0 !== pID ? pID : ''));
    }
    async get(pID) {
        return axios_1.default
            .get(this.base + APIPath.Queue + String(void 0 !== pID ? pID : ''))
            .then(function (pResponse) {
            if (void 0 === pID)
                return pResponse.data;
            return pResponse.data;
        });
    }
    async patch(pID, pPartialItem) {
        return axios_1.default.patch(this.base + APIPath.Queue + String(pID), pPartialItem);
    }
    async put(pStackQueueItem, pID) {
        const lIdStr = String(void 0 !== pID ? pID : -1);
        return axios_1.default.put(this.base + APIPath.Queue + lIdStr, pStackQueueItem);
    }
    async post(pStackQueue) {
        return axios_1.default.post(this.base + APIPath.Queue, pStackQueue);
    }
}
class _Collections {
    constructor(base) {
        this.base = base;
    }
    async post(pCollection) {
        return axios_1.default.post(this.base + APIPath.Collections, { config: pCollection });
    }
    async deploy(pCollectionId, pSystemIps) {
        return axios_1.default.post(this.base + APIPath.Collections + pCollectionId, pSystemIps);
    }
    async edit(pCollection, id) {
        return axios_1.default.put(this.base + APIPath.Collections + id, {
            config: pCollection,
        });
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.Collections)
            .then((pRes) => {
            return pRes.data;
        });
    }
    async getCollection(id) {
        return axios_1.default
            .get(this.base + APIPath.Collections + id)
            .then((pRes) => {
            return pRes.data;
        });
    }
    async delete(id) {
        return axios_1.default
            .delete(this.base + APIPath.Collections + id)
            .then((pRes) => {
            return pRes.data;
        });
    }
}
class _Generic {
    constructor(base) {
        this.base = base;
    }
    async get(...pArgs) {
        const lFlattenedArgs = pArgs.flat();
        return axios_1.default
            .get(this.base + APIPath.Generic, {
            params: { keys: lFlattenedArgs },
        })
            .then((pRes) => {
            return pRes.data;
        });
    }
    async getRobotConfig() {
        return this.get('preferences').then(function (pData) {
            if (pData['robot_configurations'])
                return JSON.parse(pData['robot_configurations']);
            return void 0;
        });
    }
    set(pKeys = [], pData) {
        return axios_1.default.put(this.base + APIPath.Generic, pData, {
            params: { keys: pKeys },
        });
    }
}
class _Config {
    constructor(base) {
        this.base = base;
    }
    async factoryReset() {
        return axios_1.default.post(this.base + APIPath.FactoryReset);
    }
    async uploadConfigs(files) {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('configs', files[i]); // 'configs' is the key expected by the server
        }
        return axios_1.default.post(this.base + APIPath.UploadConfigs, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    async getBaselineConfigs() {
        return axios_1.default
            .get(this.base + APIPath.BaselineConfigs)
            .then((res) => {
            return res.data;
        });
    }
}
class _Version {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default.get(this.base + APIPath.Version).then((r) => {
            return r.data;
        });
    }
}
class _Pack {
    constructor(base) {
        this.base = base;
    }
    async pack(PL, PW, BL, BW) {
        PL = Math.round(PL);
        PW = Math.round(PW);
        BL = Math.round(BL);
        BW = Math.round(BW);
        return axios_1.default
            .get(this.base + APIPath.Pack, { params: { PL, PW, BL, BW } })
            .then((res) => {
            return res.data;
        });
    }
}
class _Pallet {
    constructor(base) {
        this.base = base;
    }
    _gen_cf(config) {
        let cf = config;
        // let [acts, _] = generateStandardPath(config, machine_config);
        // cf.Actions = acts;
        cf.Actions = [];
        delete cf.name;
        return cf;
    }
    update(config) {
        const cf = this._gen_cf(config);
        return axios_1.default.put(this.base + APIPath.Pallet, cf);
    }
    delete() {
        return axios_1.default.delete(this.base + APIPath.Pallet);
    }
    async get() {
        return axios_1.default.get(this.base + APIPath.Pallet).then((res) => {
            return blackbox_1.PalletConfigObj.from(res.data);
        });
    }
}
class _CoreAppConfig {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.CoreAppConfig)
            .then((r) => {
            return r.data;
        });
    }
    async update(config) {
        return axios_1.default.put(this.base + APIPath.CoreAppConfig, config);
    }
}
class _VRDFConfig {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.VRDFConfig)
            .then((r) => {
            return r.data;
        });
    }
    async update(config) {
        return axios_1.default.put(this.base + APIPath.VRDFConfig, config);
    }
}
class _CoreIOConfig {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.CoreIOConfig)
            .then((r) => {
            return r.data;
        });
    }
    async update(config) {
        return axios_1.default.put(this.base + APIPath.CoreIOConfig, config);
    }
}
class _GripperConfig {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.GripperConfig)
            .then((r) => {
            return r.data;
        });
    }
    async update(config) {
        return axios_1.default.put(this.base + APIPath.GripperConfig, config);
    }
}
class _Machine {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default.get(this.base + APIPath.Machine).then((r) => {
            return r.data;
        });
    }
    update(config) {
        return axios_1.default.put(this.base + APIPath.Machine, config);
    }
}
class _SKUSpecific {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.SKUSpecific)
            .then((r) => {
            return r.data;
        });
    }
    async update(config) {
        return axios_1.default.put(this.base + APIPath.SKUSpecific, config);
    }
    async delete(id) {
        return axios_1.default.delete(this.base + APIPath.SKUSpecific + '/' + id);
    }
}
class _CoreLogs {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default.get(this.base + APIPath.CoreLogs).then((r) => {
            return r.data;
        });
    }
}
class _InfoLogs {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default.get(this.base + APIPath.InfoLogs).then((r) => {
            return r.data;
        });
    }
    push(item) {
        return axios_1.default.post(this.base + APIPath.InfoLogs, item);
    }
}
class _StatusItems {
    constructor(base) {
        this.base = base;
    }
    async get() {
        return axios_1.default
            .get(this.base + APIPath.StatusItems)
            .then((r) => {
            return r.data;
        });
    }
    push(items) {
        return axios_1.default.post(this.base + APIPath.StatusItems, items);
    }
}
class _Commands {
    constructor(base) {
        this.base = base;
    }
    async send(data) {
        return axios_1.default.post(this.base + APIPath.Command, data);
    }
}
class API {
    constructor(host, port = 8001) {
        this.webDeployment = undefined != host.match(/palletizer\.vention\.(io|com)/);
        if (port === 0)
            this.webDeployment = true;
        const base = this.webDeployment
            ? `https://${host}`
            : `http://${host}:${port}`;
        this.Pallet = new _Pallet(base);
        this.Machine = new _Machine(base);
        this.CoreAppConfig = new _CoreAppConfig(base);
        this.VRDFConfig = new _VRDFConfig(base);
        this.GripperConfig = new _GripperConfig(base);
        this.SKUSpecific = new _SKUSpecific(base);
        this.CoreLogs = new _CoreLogs(base);
        this.CoreIOConfig = new _CoreIOConfig(base);
        this.Pack = new _Pack(base);
        this.Generic = new _Generic(base);
        this.Queue = new _Queue(base);
        this.Collections = new _Collections(base);
        this.InfoLogs = new _InfoLogs(base);
        this.StatusItems = new _StatusItems(base);
        this.Commands = new _Commands(base);
        this.Config = new _Config(base);
        this.Version = new _Version(base);
    }
    isWebDeployment() {
        return this.webDeployment;
    }
}
exports.API = API;
